export default __webpack_public_path__ + "static/media/extra-comfort.17051ea8.svg";